module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "praise-for-a-justifiable-madness"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "praise-for-a-justifiable-madness-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for A Justifiable Madness:")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "praise-for-a-justifiable-madness-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("I")]), _vm._v(" was")]), _vm._v(" in my element here it was like One Flew Over the Cuckoo’s Nest.\" "), _c('b', [_vm._v("Susan Hampson - Books From Dusk Till "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Dawn")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This is a fascinating and insightful thriller about psychiatric treatment and diagnosis.\" "), _c('b', [_vm._v("Caroline Vincent - Bits About "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Books")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This is a really well written and unique storyline. As an avid blogger I crave unique storylines and I applaud the author on such a brilliant debut novel.\" "), _c('b', [_vm._v("Philomena Callan - Cheekypee Reads And "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"A fantastically gripping read that I struggled to put down!\" "), _c('b', [_vm._v("Kate Noble - The Quiet "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Knitter")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This story will make you wander who is the madman and what goes on within the system...A dark little twister of a read...\" "), _c('b', [_vm._v("Livia Sbarbaro - Goodreads "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Revewier")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This is a great book that will keep you gripped throughout\" "), _c('b', [_vm._v("Julie Lacey - Goodreads "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviewer")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d599f3d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praiseforajustifiablemadness.vue
// module id = 75
// module chunks = 0